<template>
  <page-outline :title="$t('Webheader.verifications')">
    <template slot="pageContent">
      <b-row>
        <b-col md="2">
          <back-button :returnUrl="returnUrl"></back-button>
        </b-col>
      </b-row>
      <br>
      <b-row>
        <b-col sm="3" class="form-group">
          <form-write-group-label-input v-model="siren"
            :inputLabel="$t('verifications.lblSIREN')"
            :placeholderValue="$t('verifications.placeHSIREN')"
            :mandatoryErrorIndicator="sirenError"
            :regexpErrorIndicator="sirenRegexpError">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="3" class="form-group">
          <form-write-group-label-input v-model="siret"
            :inputLabel="$t('verifications.lblSIRET')"
            :placeholderValue="$t('verifications.placeHSIRET')"
            :mandatoryErrorIndicator="siretError"
            :regexpErrorIndicator="siretRegexpError">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="3" class="form-group">
          <form-write-group-label-input v-model="vatNumber"
            :inputLabel="$t('verifications.lblVATNumber')"
            :placeholderValue="$t('verifications.placeHVATNumber')"
            :mandatoryErrorIndicator="vatNumberError"
            :regexpErrorIndicator="vatNumberRegexpError">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="3" class="form-group">
          <form-write-group-label-input v-model="socialReason"
            :inputLabel="$t('verifications.lblSocialReason')"
            :placeholderValue="$t('verifications.placeHSocialReason')"
            :mandatoryErrorIndicator="socialReasonError"
            :regexpErrorIndicator="socialReasonRegexpError">
          </form-write-group-label-input>
        </b-col>
      </b-row>
      <br>
      <b-row>
        <b-col sm="3" class="form-group">
          <form-write-group-label-input
          :inputType="'listeSelect'"
          :inputLabel="$t('suppliers.legal_status')">
            <select class="form-control" id="sel2" readonly v-model="legal_form">
              <option value="">{{ $t('suppliers.slct_legal_status') }}</option>
              <option v-for="status in legalStatusList[countryCode]" :key="status.code" :value="status.code">
                {{ status.label }}
              </option>
            </select>
          </form-write-group-label-input>
        </b-col>
        <!-- <b-col sm="3" class="form-group">
          <form-write-group-label-input v-model="social_reason"
            :inputLabel="$t('common.social_reason')"
            :placeholderValue="$t('common.social_reason')">
          </form-write-group-label-input>
        </b-col> -->
        <b-col class="form-group">
          <div>
            <label>
              {{ $t('common.dt_crtn') }}
            </label>
            <input v-model="registration_date"
              type="date"
              class="form-control inputAccordionForm"
              :placeholder="$t('common.dt_crtn')">
            </input>
          </div>
        </b-col>
        <b-col class="form-group">
          <form-write-group-label-input v-model="naf_code"
            :inputLabel="$t('suppliers.core_business')"
            :inputType="'listeSelect'">
            <select class="form-control" id="sel2" readonly v-model="naf_code">
              <option value="">{{ $t('suppliers.slct_naf_status') }}</option>
              <option v-for="status in nafStatusList[countryCode]" :key="status.code" :value="status.code">
                {{ status.label }}
              </option>
            </select>
          </form-write-group-label-input>
        </b-col>
        <b-col sm="3" class="form-group">
          <form-write-group-label-input v-model="street_name"
            :inputLabel="$t('common.adrs')"
            :placeholderValue="$t('common.adrs')">
          </form-write-group-label-input>
        </b-col>
      </b-row>
      <br>
      <b-row>
        <b-col sm="3" class="form-group">
          <form-write-group-label-input v-model="zipcode"
            :inputLabel="$t('common.zp_code')"
            :placeholderValue="$t('common.zp_code')">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="3" class="form-group">
          <form-write-group-label-input v-model="city"
            :inputLabel="$t('common.cty')"
            :placeholderValue="$t('common.cty')">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="3" class="form-group">
        </b-col>
        <b-col sm="3" class="form-group">
        </b-col>
      </b-row>
      <!-- <b-row>
        <b-col sm="6" class="form-group">
          <b-form-checkbox v-model="getUBOs"
            :value="true" :unchecked-value="false">
            {{ 'Récupérer les bénéficiaires effectifs' }}
          </b-form-checkbox>
        </b-col>
      </b-row> -->

      <div v-if="entities.length > 1">
        <b-row style="margin-top:10px;">
          <b-col cols="12" class="form-group">
            <span class="font-italic">
              {{ $t('verifications.select_result') }}
            </span>
          </b-col>
        </b-row>
        <div v-for="(entity, index) in entities" :key="index"
          class="cadreCorporate" style="margin-top:10px;"
          @click="redirectDetails(entity, entity.IdVerificationsHistory)">
          <b-row>
            <b-col sm="4" class="h4 text-left">
              SIREN : {{ entity.SIRENUnit }}
            </b-col>
            <b-col sm="8" class="h4 text-left">
              {{ entity.Denomination }}
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="4" class="h6 text-left">
              SIRET : {{ entity.SIRET }}
            </b-col>
            <b-col sm="8" class="h6 text-left">
              {{ entity.CustomAddress }}
            </b-col>
          </b-row>
          <b-row>
            <b-col class="h6 text-left" style="margin-bottom:0;">
              Activité principale : {{ entity.ActivityLabel }}
            </b-col>
          </b-row>
        </div>
      </div>
      <b-row class="mt-3">
        <b-col cols="12" sm="4" lg="2" offset="0" offset-sm="8">
          <b-button variant="primary"
            class="text-center"
            size="sm"
            @click="verificationSend">
            {{ $t('verifications.btnSubVerification') }}
          </b-button>
        </b-col>
      </b-row>
    </template>
  </page-outline>
</template>

<script>
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import backButton from '@/components/common/backButton.vue'

import {errorMessageAlert} from '@/helpers/alert'
import { loadPage } from '@/helpers/routing'
import {verifyMandatoryValues, verifyRegexpValues, checkErrorFlag} from '@/helpers/validator'
import legalStatusList from './data/legalstatus.json'
import nafStatusList from '@/data/nafstatus.json'
import moment from 'moment'

export default {
  name: 'VerificationsCreateTemplate',
  components: {
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,
    'back-button': backButton
  },
  data () {
    return {
      entities: [],
      getUBOs: false,
      siren: '',
      sirenError: false,
      sirenRegexpError: false,
      siret: '',
      siretError: false,
      siretRegexpError: false,
      legalStatusList: legalStatusList,
      nafStatusList: nafStatusList,
      socialReason: '',
      socialReasonError: false,
      socialReasonRegexpError: false,
      vatNumber: '',
      vatNumberError: false,
      vatNumberRegexpError: false,
      legal_form: '',
      social_reason: '',
      registration_date: '',
      naf_code: '',
      street_name: '',
      zipcode: '',
      city: '',
      countryCode: 'FR'
    }
  },
  created () {
  },
  methods: {
    // databaseLegalStatuslabel () {
    //   if (this.databaseLegalStatus !== '') {
    //     var foundLabel = ''
    //     this.legalStatusList[this.countryCode].map(legalForm => {
    //       if (this.databaseLegalStatus === legalStatus.code) {
    //         foundLabel = legalStatus.label
    //       }
    //     })
    //     return foundLabel
    //   }
    // },
    verifyCompany () {
      let that = this
      this.$f7.showPreloader(this.$i18n.t('loading.loading_general'))
      let params = {
        siren: this.siren,
        siret: this.siret,
        social_reason: this.socialReason,
        registration_date: this.registration_date,
        naf_code: this.naf_code,
        legal_form: this.legal_form,
        street_name: this.street_name,
        zipcode: this.zipcode,
        city: this.city
      }
      this.$engine.services.verifications.verifyCompany(params)
      .then(response => {
        if (response.status === 200) {
          that.$f7.hidePreloader()
          this.redirectDetails(response.data, response.data.IdVerificationsHistory)
        }
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    redirectDetails (entity, id) {
      entity.getUBOs = this.getUBOs
      entity.verify = false
      // adding data given in entity
      this.registration_date = moment(this.registration_date).format('yyyy-MM-DD')
      if (this.registration_date === 'Invalid date') {
        this.registration_date = ''
      }
      if (this.vatNumber && !this.siren_given) {
        this.siren = this.vatNumber.slice(-9)
      }
      entity.siren_given = this.siren
      entity.siret_given = this.siret || entity.SIRET
      entity.legal_form_given = this.legal_form
      // entity.social_reason_given = this.social_reason
      entity.social_reason_given = this.socialReason
      entity.registration_date_given = this.registration_date
      entity.naf_code_given = this.naf_code
      entity.street_name_given = this.street_name
      entity.zipcode_given = this.zipcode
      entity.city_given = this.city
      console.log('entity verify', entity)
      this.$engine.services.suppliers.selectedEntity = entity
      loadPage(this, { url: '/verifications/details/' + id})
    },
    validateForm () {
      let flagsList = {}
      let mandatoryValues = []
      // let mandatoryValues = ['siren']
      let regexpValues = {
        'siren': 'SIREN',
        'siret': 'SIRET'
      }
      flagsList = verifyMandatoryValues(mandatoryValues, flagsList, this)
      flagsList = verifyRegexpValues(regexpValues, flagsList, this)
      let errorFlag = checkErrorFlag(flagsList)
      return !errorFlag
    },
    verificationSend () {
      if (!this.validateForm()) {
        this.$f7.alert(this.$i18n.t('errors.errors_in_form_details'), this.$i18n.t('errors.errors_in_form'))
        return
      }

      this.$f7.showPreloader(this.$i18n.t('loading.verification_loader'))

      let params = {
        CountryCode: 'FR'
      }

      let paramsContent = {
        CdAppli: 'C4',
        Entities: []
      }

      let entityToSearch = {
        LegalUnitOnly: '0',
        MaxResults: '10',
        GetInpiData: '0',
        GetInpiActs: '0'
      }

      if (this.siren) {
        entityToSearch.SIREN = {
          Rule: 'strict',
          Value: this.siren
        }
        entityToSearch.StatusOpenOnly = '0'
      }
      if (this.siret) {
        entityToSearch.SIRET = {
          Rule: 'strict',
          Value: this.siret
        }
        entityToSearch.StatusOpenOnly = '0'
      }
      if (!this.siret && !this.siren && this.socialReason) { //modif here
        entityToSearch.Name = {
          Rule: 'strict', // à remplacer par contain plus tard
          Value: this.socialReason
        }
        entityToSearch.StatusOpenOnly = '1'
      }

      paramsContent.Entities.push(entityToSearch)

      params.content = paramsContent

      let that = this
      this.$engine.services.suppliers.getLegalStatus(params)
        .then(response => {
          if (response.status === 200) {
            that.$f7.hidePreloader()
            that.entities = response.data.Response.Entities[0].Results.Establishments
            if (!that.entities) {
              alert(that.$i18n.t('errors.no_results_found_from_API'))
            } else if (that.entities.length === 1) {
              // let entity = that.entities
              let entity = response.data.Response.Entities[0].Results.Establishments[0]
              console.log('here')
              that.verifyCompany()
              //that.redirectDetails(entity, 0)
            } else {
              for (var i = 0; i < that.entities.length; i++) {
                that.entities[i].CustomAddress = ''
                let addressElements = ['StreetNumber', 'StreetNumberRepetition', 'StreetType', 'StreetName', 'PostalCode', 'TownName']
                for (let indexElement in addressElements) {
                  let element = addressElements[indexElement]
                  if (that.entities[i][element]) {
                    if (that.entities[i].CustomAddress === '') {
                      that.entities[i].CustomAddress += that.entities[i][element]
                    } else {
                      that.entities[i].CustomAddress += ' ' + that.entities[i][element]
                    }
                  }
                }
              }
            }
          }
        })
        .catch(error => {
          that.$f7.hidePreloader()
          errorMessageAlert(error, that)
        })
    }
  }
}
</script>

<style>
.cadreCorporate {
  background-color: white;
  border: 1px solid grey;
  cursor: pointer;
  padding: 20px;
  width: 100%;
}
.cadreCorporate:hover {
  border: 2px solid rgb(18, 188, 241);
  cursor: pointer;
}
</style>
